import React, { useEffect, useContext, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
} from '@material-ui/core';
import {
  User as UserIcon,
  FileText as FileTextIcon,
  LogOut as LogOutIcon,
  X as XIcon,
} from 'react-feather';

import NavItem from './NavItem';
import LogoDashboard from './LogoDashboard';

import { getCurrentUser, logout } from "../utils/auth"

export const itemsMenu = [
  {
    href: '/app/scans',
    title: 'Scans'
  },
  {
    href: '/app/account',
    title: 'Compte'
  },
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const currentUser = getCurrentUser()
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);


  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box sx={{height:"65px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>
        <RouterLink to="/" style={{marginLeft:"20px", display:"flex", alignItems:"center"}}>
          <LogoDashboard />
        </RouterLink>
        <XIcon size="25" style={{cursor:"pointer", color:"black", marginRight:"20px" }} onClick={onMobileClose}/>
      </Box>
      <Box sx={{ p: 2 }}>
        <List>
          {itemsMenu.map((item, index) => (
            <React.Fragment key={index}>
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
              <Divider />
            </React.Fragment>
          ))}
          <Hidden lgUp>
            <NavItem
              withoutEndIcon
              title='Déconnexion'
              onClick={() => {
                logout(() => navigate("/"))
              }}
            />
          </Hidden>
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      {/*<Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>*/}
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {
  },
  openMobile: false
};

export default DashboardSidebar;
